import { FOfferType } from '@/packages/JsonQuery';

import { type IOfferType } from '../../../types';

export const OFFER_TYPES_SALE_COMMERCIAL: IOfferType[][] = [
  [{ label: 'Офис', value: FOfferType.Office }],
  [
    {
      label: 'Торговая площадь',
      value: FOfferType.TradeArea,
      // TODO выяснить зачем нужен был shortLabel
      // shortLabel: 'Торговую площадь',
    },
    { label: 'Склад', value: FOfferType.Warehouse },
    {
      label: 'Помещение свободного назначения',
      value: FOfferType.FreeAppointmentObject,
      // shortLabel: 'Свобод. назнач.',
    },
    { label: 'Общепит', value: FOfferType.PublicCatering },
    { label: 'Производство', value: FOfferType.Manufacture },
    { label: 'Автосервис', value: FOfferType.AutoService },
    { label: 'Здание', value: FOfferType.Building },
    { label: 'Бытовые услуги', value: FOfferType.DomesticServices },
    // TODO выяснить нужно ли разделение на арендный и готовый бизнес
    {
      label: 'Арендный бизнес',
      value: FOfferType.RentalBusiness,
      // description: 'Помещение в собственности c арендатором на долгий срок',
    },
    {
      label: 'Готовый бизнес',
      value: FOfferType.ReadyBusiness,
      // description: 'Помещение в собственности или аренде с юрлицом, имуществом и сотрудниками',
    },
  ],
  [
    {
      label: 'Коммерческая земля',
      value: FOfferType.CommercialLand,
      // TODO выяснить зачем нужен был shortLabel
      // shortLabel: 'Коммерч. землю',
    },
  ],
];

export const OFFER_TYPES_RENT_COMMERCIAL: IOfferType[][] = [
  [{ label: 'Офис', value: FOfferType.Office }],
  [
    // TODO сделать отдельную хрень Coworking (2 в 1) -> для CoworkingWorkplace и CoworkingOffice
    { label: 'Офис в коворкинге', value: FOfferType.Coworking },
    { label: 'Рабочее место', value: FOfferType.Coworking },
  ],
  [
    {
      label: 'Торговая площадь',
      value: FOfferType.TradeArea,
      // TODO выяснить зачем нужен был shortLabel
      // shortLabel: 'Торговую площадь',
    },
    { label: 'Склад', value: FOfferType.Warehouse },
    {
      label: 'Помещение свободного назначения',
      value: FOfferType.FreeAppointmentObject,
      // shortLabel: 'Свобод. назнач.',
    },
    { label: 'Общепит', value: FOfferType.PublicCatering },
    { label: 'Производство', value: FOfferType.Manufacture },
    { label: 'Автосервис', value: FOfferType.AutoService },
    { label: 'Здание', value: FOfferType.Building },
    { label: 'Бытовые услуги', value: FOfferType.DomesticServices },
  ],
  [
    {
      label: 'Коммерческая земля',
      value: FOfferType.CommercialLand,
      // TODO выяснить зачем нужен был shortLabel
      // shortLabel: 'Коммерч. землю',
    },
  ],
];
